import { ReactNode, useState } from 'react'
import { ModalContext } from '../context'
import type { ModalData, ModalDataState, ModalState } from './types'

export const ModalProvider = ({ children }: { children: ReactNode }) => {
    const [modals, setModals] = useState<ModalState>({})
    const [modalData, setModalData] = useState<ModalDataState>({})

    const openModal = (modalName: string, data?: ModalData) => {
        // Set the modal to open
        setModals((prevState) => ({
            ...prevState,
            [modalName]: true,
        }))

        // If data is provided, update the modal data
        if (data) {
            setModalData((prevData) => ({
                ...prevData,
                [modalName]: {
                    ...(prevData[modalName] || {}),
                    ...data,
                },
            }))
        }
    }

    const closeModal = (modalName: string) => {
        setModals((prevState) => ({
            ...prevState,
            [modalName]: false,
        }))
    }

    return (
        <ModalContext.Provider
            value={{ modals, modalData, openModal, closeModal }}
        >
            {children}
        </ModalContext.Provider>
    )
}
